export const getTranslationPrefix = (t, forSelf) => {
    return forSelf ? t("self") : t("other");
};

export const getDynamicTranslation = (t, prefix, key) => {
    const dynamicKey = `${prefix}_${key}`;
    return t(dynamicKey);
};
